module.exports = __webpack_public_path__ + "enlarge-spend.svg?b35ecd712d1e32bfcca3727f5c73c535";